import { InjectionToken } from '@angular/core';

export const HAS_TO_SHOW_NOTIFICATIONS_TOKEN = new InjectionToken<boolean>('HAS_TO_SHOW_NOTIFICATIONS');
